<template>
  <div id="app">
    <div class="container">
      <div class="row align-items-center">
        <div :class="activeStep > 1 ? 'col-3 col-md-3 mob-place-2' : 'col-5 col-md-3'" ref="icon">
          <div v-if="activeStep === 1">
            <div class="title-small">Быстрый расчет материалов и<br>комплектующих!</div>
            <div class="title-big">4 простых шага</div>
          </div>
          <div v-if="activeStep === 2" class="mob-icon-material">
            <img :width="mobile ? '67%' : '50%'" src="./assets/images/icon_kalculyator-01.svg" alt="">
          </div>

          <div v-if="activeStep === 3 || activeStep === 4">
            <img width="70%" src="./assets/images/icon_kalculyator-02.svg" alt="">
          </div>

          <div v-if="activeStep > 1 && mobile" class="search-material-container">
            <div v-if="materialImage === ''" class="search-material"></div>
            <div v-if="materialImage !== ''" class="search-material"><img :src="getImgUrl(materialImage, 'search')" alt=""></div>
          </div>
        </div>
          <div :class="activeStep > 1 ? 'col-md-6 col-9 mob-place-1' : 'col-md-6 col-7'">
            <div class="house" ref="printHouse" id="printHouse">
              <img v-if="materialImage === ''" src="./assets/images/house/Kirpich polnotelyy.jpg" alt="">
              <img v-if="materialImage !== ''" :src="getImgUrl(materialImage, 'house')" alt="">
            </div>
          </div>
        <div v-if="!mobile" class="col-3 result-container" >
          <div ref="printResult" id="printResult">
            <h4>Размеры здания:</h4>
            <div>
              <span v-if="fields.length.value">Длина - {{fields.length.value}} {{fields.length.meas}}</span>
              <span v-if="fields.height.value"> / Высота - {{fields.height.value}} {{fields.height.meas}}</span>
              <span v-if="fields.width.value"> / Ширина - {{fields.width.value}} {{fields.width.meas}}</span>
            </div>
            <span v-if="fields.square.value">Площадь - {{fields.square.value}} {{fields.square.meas}} <sup>2</sup></span>
            <div v-if="countWindows > 0">Количество окон: {{countWindows}}</div>
            <div v-if="countDoors > 0">Количество дверей: {{countDoors}}</div>
            <div v-if="materialWall !== ''">Тип стены: {{materialWall}}</div>
            <div v-if="finishing !== ''">Тип отделки: {{finishing}}</div>
            <div v-if="insulationTitle !== ''">Вид утеплителя: {{insulationTitle}}</div>
            <div v-if="insulationWidth !== ''">Толщина утеплителя: {{insulationWidth}}</div>
            <div v-if="materialFinishing !== ''">Тип штукатурки: {{materialFinishing}}</div>
            <div v-if="materialFinishingTexture !== ''">Фактура: {{materialFinishingTexture}}</div>
            <div v-if="materialFinishingSize !== ''">Размер зерна: {{materialFinishingSize}}</div>
            <div v-if="materialFinishingCoating !== ''">Финишное покрытие: {{materialFinishingCoating}}</div>
          </div>

          <div v-if="activeStep > 1" class="search-material-container">
            <div v-if="materialImage === ''" class="search-material"></div>
            <div v-if="materialImage !== ''" class="search-material"><img :src="getImgUrl(materialImage, 'search')" alt=""></div>
          </div>

        </div>
        <div class="col-12" v-if="checkMod">
          <div>Площадь окон и дверей: {{squareWindowDoors}}</div>
          <div>площадь фасада без окон и дверей: {{squareFacade}}</div>
          <div>Периметр под уголок с сеткой: {{perimeterCorner}}</div>
          <div>Периметр под "Профиль оконного примыкания": {{perimeterProfile}}</div>
          <div>Периметр под "Профиль-капельник": {{perimeterDrip}}</div>
          <div>Расчёт размера дюбеля: {{dowelSize}}</div>
          <div>Периметр под цокольный профиль: {{perimeterPlinth}}</div>
        </div>
      </div>
      <div class="row timeline">
        <div v-if="!mobile" class="col-2"></div>
        <div :class="step === activeStep ? 'col-md-2 col-3 step active' : 'col-md-2 col-3 step'" v-for="step in steps">{{step}}</div>
        <div class="col-md-8 offset-md-2 col-12"><div class="line"><div :style="{ width: (25 * activeStep) + '%' }" class="filled-line"></div></div></div>
      </div>
      <div class="row actions">
        <div class="col-md-8 offset-md-2 col-12">
          <div class="row" v-if="activeStep === 1">
            <div class="col-6" v-for="button in buttons[activeStep]">
              <div @click="changeActiveButton(button.id)" :class="buttonsStep === button.id ? 'button-action active' : 'button-action'">{{button.title}}</div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="fields">
            <div class="row">
              <div class="col-md-8 offset-md-2 col-12">
                <div class="box" v-if="buttonsStep === 1">
                  <div class="row">
                    <div class="col-md-4 col-12">
                      <div class="input-group">
                        <label>{{fields.length.title}}</label>
                        <input type="text" v-model="fields.length.value" @keypress="isNumber($event)">
                        <span>{{fields.length.meas}}</span>
                      </div>
                    </div>
                    <div class="col-md-4 col-12">
                      <div class="input-group">
                        <label>{{fields.width.title}}</label>
                        <input type="text" v-model="fields.width.value" @keypress="isNumber($event)">
                        <span>{{fields.width.meas}}</span>
                      </div>
                    </div>
                    <div class="col-md-4 col-12">
                      <div class="input-group">
                        <label>{{fields.height.title}}</label>
                        <input type="text" v-model="fields.height.value" @keypress="isNumber($event)">
                        <span>{{fields.height.meas}}</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="box" v-if="buttonsStep === 2">
                  <div class="row">
                    <div class="col-md-3 offset-md-5 col-5 offset-4">
                      <div class="input-group">
                        <input class="long" type="text" v-model="fields.square.value" @keypress="isNumber($event)">
                        <span>{{fields.square.meas}}<sup>2</sup></span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="box" v-if="activeStep === 1">
                  <div class="row">
                    <div class="col-12">
                      <div class="box-title">Укажите размеры и количество окон и дверей</div>
                    </div>
                  </div>
                  <div class="row align-items-end mb-4" v-for="(item, index) in fields.windows">
                    <div class="col-2 label-field">Окно</div>
                    <div class="col-3 mob-padding-0">
                      <div class="input-group">
                        <div class="title-field">{{item.width.title}}</div>
                        <div>
                          <input class="long" type="text" v-model="item.width.value" @keypress="isNumber($event)">
                          <span>{{item.width.meas}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-3 mob-padding-0">
                      <div class="input-group">
                        <div class="title-field">{{item.height.title}}</div>
                        <div>
                          <input class="long" type="text" v-model="item.height.value" @keypress="isNumber($event)">
                          <span>{{item.height.meas}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-3 mob-padding-0">
                      <div class="input-group">
                        <div class="title-field">{{item.count.title}}</div>
                        <div>
                          <input class="long" type="text" v-model="item.count.value" @keypress="isNumber($event)">
                          <span>{{item.count.meas}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-1 mob-padding-0 mob-mb"><close-icon @click="deleteWindow(index)" class="action-delete"/></div>
                  </div>
                  <div class="row align-items-end mb-4" v-for="(item, index) in fields.doors">
                    <div class="col-2 label-field">Дверь</div>
                    <div class="col-3 mob-padding-0">
                      <div class="input-group">
                        <div class="title-field">{{item.width.title}}</div>
                        <div>
                          <input class="long" type="text" v-model="item.width.value" @keypress="isNumber($event)">
                          <span>{{item.width.meas}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-3 mob-padding-0">
                      <div class="input-group">
                        <div class="title-field">{{item.height.title}}</div>
                        <div>
                          <input class="long" type="text" v-model="item.height.value" @keypress="isNumber($event)">
                          <span>{{item.height.meas}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-3 mob-padding-0">
                      <div class="input-group">
                        <div class="title-field">{{item.count.title}}</div>
                        <div>
                          <input class="long" type="text" v-model="item.count.value" @keypress="isNumber($event)">
                          <span>{{item.count.meas}}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-1 mob-padding-0 mob-mb"><close-icon @click="deleteDoor(index)" class="action-delete"/></div>
                  </div>
                  <div class="row actions">
                    <div class="col-auto mr-5"><div class="button-add" @click="addItem">Добавить окно</div></div>
                    <div class="col-auto"><div class="button-add" @click="addDoor">Добавить дверь</div></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" v-if="activeStep === 2">
              <div class="col-md-8 offset-md-2 col-12">
                <div class="row select-button-container">
                  <div class="col-12">
                    <div class="box-title ml-md-5">Выберите материал стены</div>
                  </div>
                  <div class="col-md-4 p-2 col-6 choose-button" v-for="field in fields.materialsWall">
                    <div @click="selectMaterialWall(field.title)" :class="materialWall ===  field.title ? 'select-button active' : 'select-button'"><div>{{field.title}}</div></div>
                  </div>
                  <div class="col-12">
                    <div class="box-title ml-md-5">Выберите вид отделки</div>
                  </div>
                  <div class="col-6 p-2 choose-button" v-for="field in fields.finishing">
                    <div @click="selectFinishing(field.title)" :class="finishing ===  field.title ? 'select-button active' : 'select-button'"><div>{{field.title}}</div></div>
                  </div>
                  <div v-if="insulation" class="col-12">
                    <div class="box-title ml-md-5">Выберите вид утеплителя</div>
                  </div>
                  <div v-if="insulation" class="col-6 p-2 choose-button" v-for="field in fields.insulation">
                    <div @click="selectInsulation(field.title)" :class="insulationTitle ===  field.title ? 'select-button active' : 'select-button'"><div>{{field.title}}</div></div>
                  </div>
                  <div v-if="insulation" class="col-12">
                    <div class="box-title ml-md-5">Выберите толщину утеплителя</div>
                  </div>
                  <div v-if="insulation" class="col-md col-6 p-2 choose-button" v-for="field in fields.insulationWidth">
                    <div @click="selectInsulationWidth(field.title)" :class="insulationWidth ===  field.title ? 'select-button active' : 'select-button'"><div>{{field.title}}</div></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" v-if="activeStep === 3">
              <div class="col-md-8 offset-md-2 col-12">
                <div class="row select-button-container">
                  <div class="col-12">
                    <div class="box-title ml-md-5">Выберите вид штукатурки</div>
                  </div>
                  <div :class="materialsFinishing.length === 4 ? 'col-md-3 col-6 p-2 choose-button' : 'col-md-4 col-6 p-2 choose-button'" v-for="field in materialsFinishing">
                    <div @click="selectMaterialFinishing(field.title)" :class="materialFinishing ===  field.title ? 'select-button active' : 'select-button'"><div>{{field.title}}</div></div>
                  </div>
                  <div class="col-12">
                    <div class="box-title ml-md-5">Выберите вид фактуры штукатурки</div>
                  </div>
                  <div class="col-6 p-2 choose-button" v-for="field in fields.materialsFinishingTexture">
                    <div @click="selectMaterialFinishingTexture(field.title)" :class="materialFinishingTexture ===  field.title ? 'select-button active' : 'select-button'"><div>{{field.title}}</div></div>
                  </div>
                  <div class="col-12">
                    <div class="box-title ml-md-5">Выберите размер зерна штукатурки</div>
                  </div>
                  <div class="col-md-4 p-2 choose-button col-6" v-for="field in fields.materialsFinishingSize">
                    <div @click="selectMaterialFinishingSize(field.title)" :class="materialFinishingSize ===  field.title ? 'select-button active' : 'select-button'"><div>{{field.title}}</div></div>
                  </div>
                  <div class="col-12" v-if="materialFinishing === 'Минеральная штукатурка'">
                    <div class="box-title ml-md-5">Выберите финишное покрытие</div>
                  </div>
                  <div class="col-md-4 p-2 col-6 choose-button" v-if="materialFinishing === 'Минеральная штукатурка'" v-for="field in fields.materialsFinishingCoating">
                    <div @click="selectMaterialFinishingCoating(field.title)" :class="materialFinishingCoating ===  field.title ? 'select-button active' : 'select-button'"><div>{{field.title}}</div></div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" v-if="activeStep === 4" ref="print" id="print">
              <div class="col-md-8 offset-md-2 col-12">
                <div class="row final">
                  <div class="col-12">
                    <div class="box-title-final ml-md-5">Расчет</div>
                  </div>
                  <div class="col-12">
                    <div class="table">
                      <div class="table-head">
                        <div class="column image">Продукт</div>
                        <div class="column name">Название</div>
                        <div class="column count">Количество</div>
                      </div>
                      <div class="table-body" v-if="item.count > 0" v-for="item in resultItems">
                        <div class="column image"><img :src="item.src" alt=""></div>
                        <div class="column name">
                          <a v-if="item.url !== 'none'" target="_blank" :href="item.url">{{item.name}}</a>
                          <span v-if="item.url === 'none'">{{item.name}}, {{insulationWidth}} </span>
                        </div>
                        <div v-if="item.url !== 'none'" class="column count">{{item.count}} шт.</div>
                        <div v-if="item.url === 'none'" class="column count">{{item.count}} м3</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <img :src="output">

            <div class="row">
              <div v-if="activeStep !== 4" class="col-md-8 offset-md-2 col-12">
                <div class="row justify-content-end">
                  <div v-if="activeStep > 1" class="col-auto">
                    <div @click="previousStep" class="previous-button">< Назад</div>
                  </div>
                  <div class="col-auto">
                    <div @click="nextStep" class="next-button">Далее</div>
                  </div>
                </div>
              </div>


              <div v-if="activeStep === 4 && !mobile" class="col-md-8 offset-md-2 col-12">
                <div class="bottom-bar">
                  <div class="item">
                    <div @click="previousStep" class="previous-button">< Назад</div>
                  </div>
                  <div class="item">
                    <div class="button-add" @click="payment('print')">Распечатать расчет</div>
                  </div>
                  <div class="item">
                    <div class="button-add" @click="payment('save')">Сохранить расчет</div>
                  </div>
                  <div class="item">
                    <div @click="showFormConsultation" class="next-button">Получить консультацию</div>
                  </div>
                </div>
              </div>
              <div v-if="activeStep === 4 && mobile" class="col-md-8 offset-md-2 col-12">
                <div class="row justify-content-between">
                  <div class="col-6">
                    <div @click="previousStep" class="previous-button">< Назад</div>
                  </div>
                  <div class="col-6">
                    <div @click="showFormConsultation" class="next-button mob">Получить консультацию</div>
                  </div>
                  <div class="col-12 mt-4">
                    <div class="button-add" @click="paymentMobile()">Сохранить или распечатать расчет</div>
                  </div>
                </div>
              </div>
              <div @click="showMobileDataExpand" class="col-12 title-mobile-data-container" v-if="mobile">
                <div class="title-mobile-data">
                  Показать вводные данные
                </div>
                <div class="title-mobile-data">
                  <img v-if="showMobileData" src="./assets/images/keyboard_arrow_down-24px.svg" alt="">
                  <img v-if="!showMobileData" src="./assets/images/keyboard_arrow_up-24px.svg" alt="">
                </div>
              </div>

              <div ref="printResultMobile" id="printResultMobile" class="col-12" v-if="mobile && showMobileData">
                <div class="mobile-data">
                  <h4>Размеры здания:</h4>
                  <div>
                    <span v-if="fields.length.value">Длина - {{fields.length.value}} {{fields.length.meas}}</span>
                    <span v-if="fields.height.value"> / Высота - {{fields.height.value}} {{fields.height.meas}}</span>
                    <span v-if="fields.width.value"> / Ширина - {{fields.width.value}} {{fields.width.meas}}</span>
                  </div>
                  <div v-if="fields.square.value">Площадь: {{fields.square.value}} {{fields.square.meas}} <sup>2</sup></div>
                  <div v-if="countWindows > 0">Количество окон: {{countWindows}}</div>
                  <div v-if="countDoors > 0">Количество дверей: {{countDoors}}</div>
                  <div v-if="materialWall !== ''">Тип стены: {{materialWall}}</div>
                  <div v-if="finishing !== ''">Тип отделки: {{finishing}}</div>
                  <div v-if="insulationTitle !== ''">Вид утеплителя: {{insulationTitle}}</div>
                  <div v-if="insulationWidth !== ''">Толщина утеплителя: {{insulationWidth}}</div>
                  <div v-if="materialFinishing !== ''">Тип штукатурки: {{materialFinishing}}</div>
                  <div v-if="materialFinishingTexture !== ''">Фактура: {{materialFinishingTexture}}</div>
                  <div v-if="materialFinishingSize !== ''">Размер зерна: {{materialFinishingSize}}</div>
                  <div v-if="materialFinishingCoating !== ''">Финишное покрытие: {{materialFinishingCoating}}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <transition name="modal" v-if="showModal">
      <div class="modal-mask">
        <div class="modal-wrapper">

          <div class="modal-container">


            <div class="modal-header-vue">
              <div class="close-vue">
                <close-icon @click="showModal = false"/>
              </div>
              <slot name="header">
                Для получения консультации и связи со специалистом оставьте ваши контакты
              </slot>
            </div>

            <div class="modal-container-wrapper">
              <div class="modal-body-vue">
                <div class="row">
                  <div class="col-12"><input placeholder="Имя" type="text" v-model="form.name"></div>
                  <div class="col-md-6 col-12"><input placeholder="E-mail" type="text" v-model="form.email"></div>
                  <div class="col-md-6 col-12"><input placeholder="Телефон" type="text" v-model="form.phone"></div>
                  <div class="col-12"><textarea placeholder="Сообщение" v-model="form.message"></textarea></div>
                </div>

              </div>

              <div class="modal-footer-vue">
                <slot name="footer">
                  <div class="row justify-content-center">
                    <div class="col-auto">
                      <div class="form-button" @click="sendForm">Отправить</div>
                    </div>
                    <div class="col-auto">
                      <p class="text-agree">Нажимая «Отправить»,  Вы соглашаетесь на обработку персональных данных и с политикой конфиденциальности</p>
                    </div>
                  </div>
                </slot>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <div class="notify-vue" v-if="notify.show">
      {{notify.message}}
    </div>

  </div>
</template>

<script>

  import CloseIcon from 'vue-material-design-icons/Close.vue';
  import ArrowUpIcon from 'vue-material-design-icons/ArrowUp.vue';
  import ArrowCollapseDownIcon from 'vue-material-design-icons/ArrowCollapseDown.vue';
  import { jsPDF } from "jspdf";
  import axios from "axios"
  import { isMobile, isTablet } from 'mobile-device-detect';


  export default {
    components: {
      CloseIcon,
      ArrowUpIcon,
      ArrowCollapseDownIcon,
    },
    name: 'App',
    data: () => ({

      showMobileData: false,
      mobile: isMobile && !isTablet,
      checkMod: false,
      form: {
        name: '',
        email: '',
        phone: '',
        message: '',
      },
      showModal: false,
      notify: {
        show: false,
        message: ''
      },
      message: 'mes',
      steps: [1, 2, 3, 4],
      activeStep: 1,
      buttonsStep: 1,
      materialWall: '',
      materialImage: 'Кирпич полнотелый',
      materialFinishing: '',
      materialFinishingSearch: '',
      materialFinishingTexture: '',
      materialFinishingSize: '',
      materialFinishingCoating: '',
      finishing: '',
      insulation: false,
      insulationTitle: '',
      insulationWidth: '',
      resultItems: [
        {
          id: 1,
          src: '',
          name: 'Акриловая штукатурка REINMANN FassadenPutz K 1,5 mm, 25кг, шуба',
          count: 0,
          url: '',
          code: 'reinmann-fassadenputz-k-1-5-mm-2-0-mm-3-0-mm-',
          type: 'Равномерно-шероховатая (шуба)',
          materialFinishing: 'Акриловая штукатурка',
          materialFinishingSize: '1,5 мм',
          sort: 4,
        },
        {
          id: 2,
          src: '',
          name: 'Акриловая штукатурка REINMANN FassadenPutz K 2,0 mm, 25кг, шуба',
          count: 0,
          url: '',
          code: 'reinmann-fassadenputz-k-1-5-mm-2-0-mm-3-0-mm-',
          type: 'Равномерно-шероховатая (шуба)',
          materialFinishing: 'Акриловая штукатурка',
          materialFinishingSize: '2,0 мм',
          sort: 4,
        },
        {
          id: 3,
          src: '',
          name: 'Акриловая штукатурка REINMANN FassadenPutz K 3,0 mm, 25кг, шуба',
          count: 0,
          url: '',
          code: 'reinmann-fassadenputz-k-1-5-mm-2-0-mm-3-0-mm-',
          type: 'Равномерно-шероховатая (шуба)',
          materialFinishing: 'Акриловая штукатурка',
          materialFinishingSize: '3,0 мм',
          sort: 4,
        },
        {
          id: 4,
          src: '',
          name: 'Акриловая штукатурка REINMANN FassadenPutz R 1,5мм, 25кг, короед',
          count: 0,
          url: '',
          code: 'reinmann-fassadenputz-k-1-5-mm-2-0-mm-3-0-mm-',
          type: 'Бороздчатая (короед)',
          materialFinishing: 'Акриловая штукатурка',
          materialFinishingSize: '1,5 мм',
          sort: 4,
        },
        {
          id: 5,
          src: '',
          name: 'Акриловая штукатурка REINMANN FassadenPutz R 2.0мм, 25кг, короед',
          count: 0,
          url: '',
          code: 'reinmann-fassadenputz-k-1-5-mm-2-0-mm-3-0-mm-',
          type: 'Бороздчатая (короед)',
          materialFinishing: 'Акриловая штукатурка',
          materialFinishingSize: '2,0 мм',
          sort: 4,
        },
        {
          id: 6,
          src: '',
          name: 'Акриловая штукатурка REINMANN FassadenPutz R 3.0мм, 25кг, короед',
          count: 0,
          url: '',
          code: 'reinmann-fassadenputz-k-1-5-mm-2-0-mm-3-0-mm-',
          type: 'Бороздчатая (короед)',
          materialFinishing: 'Акриловая штукатурка',
          materialFinishingSize: '3,0 мм',
          sort: 4,
        },
        {
          id: 7,
          src: '',
          name: 'Силикон-силикатная штукатурка REINMANN Silikon-Silikat KratzPutz K 1,5 mm, 25кг, шуба',
          count: 0,
          url: '',
          code: 'reinmann-silikon-silikat-kratzputz-k',
          type: 'Равномерно-шероховатая (шуба)',
          materialFinishing: 'Силикон-силикатная штукатурка',
          materialFinishingSize: '1,5 мм',
          sort: 4,
        },
        {
          id: 8,
          src: '',
          name: 'Силикон-силикатная штукатурка REINMANN Silikon-Silikat KratzPutz K 2,0 mm, 25кг, шуба',
          count: 0,
          url: '',
          code: 'reinmann-silikon-silikat-kratzputz-k',
          type: 'Равномерно-шероховатая (шуба)',
          materialFinishing: 'Силикон-силикатная штукатурка',
          materialFinishingSize: '2,0 мм',
          sort: 4,
        },
        {
          id: 9,
          src: '',
          name: 'Силикон-силикатная штукатурка REINMANN Silikon-Silikat KratzPutz K 3,0 mm, 25кг, шуба',
          count: 0,
          url: '',
          code: 'reinmann-silikon-silikat-kratzputz-k',
          type: 'Равномерно-шероховатая (шуба)',
          materialFinishing: 'Силикон-силикатная штукатурка',
          materialFinishingSize: '3,0 мм',
          sort: 4,
        },
        {
          id: 10,
          src: '',
          name: 'Силикон-силикатная штукатурка REINMANN Silikon-Silikat RillenPutz R 1,5 mm, 25кг, короед',
          count: 0,
          url: '',
          code: 'reinmann-silikon-silikat-rillenputz-r',
          type: 'Бороздчатая (короед)',
          materialFinishing: 'Силикон-силикатная штукатурка',
          materialFinishingSize: '1,5 мм',
          sort: 4,
        },
        {
          id: 11,
          src: '',
          name: 'Силикон-силикатная штукатурка REINMANN Silikon-Silikat RillenPutz R 2,0 mm, 25кг, короед',
          count: 0,
          url: '',
          code: 'reinmann-silikon-silikat-rillenputz-r',
          type: 'Бороздчатая (короед)',
          materialFinishing: 'Силикон-силикатная штукатурка',
          materialFinishingSize: '2,0 мм',
          sort: 4,
        },
        {
          id: 12,
          src: '',
          name: 'Силикон-силикатная штукатурка REINMANN Silikon-Silikat RillenPutz R 3,0 mm, 25кг, короед',
          count: 0,
          url: '',
          code: 'reinmann-silikon-silikat-rillenputz-r',
          type: 'Бороздчатая (короед)',
          materialFinishing: 'Силикон-силикатная штукатурка',
          materialFinishingSize: '3,0 мм',
          sort: 4,
        },
        {
          id: 13,
          src: '',
          name: 'Силиконовая штукатурка REINMANN STATUS Silikon RauhPutz K 1,5мм, 25кг, шуба',
          count: 0,
          url: '',
          code: 'reinmann-status-silikon-rauhputz-k-1-5-mm-2-0-mm-3-0-mm',
          type: 'Равномерно-шероховатая (шуба)',
          materialFinishing: 'Силиконовая штукатурка',
          materialFinishingSize: '1,5 мм',
          sort: 4,
        },
        {
          id: 14,
          src: '',
          name: 'Силиконовая штукатурка REINMANN STATUS Silikon RauhPutz K 2,0мм, 25кг, шуба',
          count: 0,
          url: '',
          code: 'reinmann-status-silikon-rauhputz-k-1-5-mm-2-0-mm-3-0-mm',
          type: 'Равномерно-шероховатая (шуба)',
          materialFinishing: 'Силиконовая штукатурка',
          materialFinishingSize: '2,0 мм',
          sort: 4,
        },
        {
          id: 15,
          src: '',
          name: 'Силиконовая штукатурка REINMANN STATUS Silikon RauhPutz K 3,0мм, 25кг, шуба',
          count: 0,
          url: '',
          code: 'reinmann-status-silikon-rauhputz-k-1-5-mm-2-0-mm-3-0-mm',
          type: 'Равномерно-шероховатая (шуба)',
          materialFinishing: 'Силиконовая штукатурка',
          materialFinishingSize: '3,0 мм',
          sort: 4,
        },
        {
          id: 16,
          src: '',
          name: 'Силиконовая штукатурка REINMANN STATUS Silikon RillenPutz R 1,5 мм, 25кг, короед',
          count: 0,
          url: '',
          code: 'reinmann-status-silikon-rillenputz-r-1-5-mm-2-0-mm-3-0-mm-',
          type: 'Бороздчатая (короед)',
          materialFinishing: 'Силиконовая штукатурка',
          materialFinishingSize: '1,5 мм',
          sort: 4,
        },
        {
          id: 17,
          src: '',
          name: 'Силиконовая штукатурка REINMANN STATUS Silikon RillenPutz R 2,0 мм, 25кг, короед',
          count: 0,
          url: '',
          code: 'reinmann-status-silikon-rillenputz-r-1-5-mm-2-0-mm-3-0-mm-',
          type: 'Бороздчатая (короед)',
          materialFinishing: 'Силиконовая штукатурка',
          materialFinishingSize: '2,0 мм',
          sort: 4,
        },
        {
          id: 18,
          src: '',
          name: 'Силиконовая штукатурка REINMANN STATUS Silikon RillenPutz R 3,0 мм, 25кг, короед',
          count: 0,
          url: '',
          code: 'reinmann-status-silikon-rillenputz-r-1-5-mm-2-0-mm-3-0-mm-',
          type: 'Бороздчатая (короед)',
          materialFinishing: 'Силиконовая штукатурка',
          materialFinishingSize: '3,0 мм',
          sort: 4,
        },
        {
          id: 19,
          src: '',
          name: 'Минеральная штукатурка REINMANN SP классик 1,5 мм, 25кг, шуба',
          count: 0,
          url: '',
          code: 'reinmann-sp-klassik',
          type: 'Равномерно-шероховатая (шуба)',
          materialFinishing: 'Минеральная штукатурка',
          materialFinishingSize: '1,5 мм',
          sort: 4,
        },
        {
          id: 20,
          src: '',
          name: 'Минеральная штукатурка REINMANN SP классик 2,0 мм, 25кг, шуба',
          count: 0,
          url: '',
          code: 'reinmann-sp-klassik',
          type: 'Равномерно-шероховатая (шуба)',
          materialFinishing: 'Минеральная штукатурка',
          materialFinishingSize: '2,0 мм',
          sort: 4,
        },
        {
          id: 21,
          src: '',
          name: 'Минеральная штукатурка REINMANN SP классик 3,0 мм, 25кг, шуба',
          count: 0,
          url: '',
          code: 'reinmann-sp-klassik',
          type: 'Равномерно-шероховатая (шуба)',
          materialFinishing: 'Минеральная штукатурка',
          materialFinishingSize: '3,0 мм',
          sort: 4,
        },
        {
          id: 22,
          src: '',
          name: 'Минеральная штукатурка REINMANN RP короед 1,5 мм, 25кг, короед',
          count: 0,
          url: '',
          code: 'reinmann-rp-koroed',
          type: 'Бороздчатая (короед)',
          materialFinishing: 'Минеральная штукатурка',
          materialFinishingSize: '1,5 мм',
          sort: 4,
        },
        {
          id: 23,
          src: '',
          name: 'Минеральная штукатурка REINMANN RP короед 2,0 мм, 25кг, короед',
          count: 0,
          url: '',
          code: 'reinmann-rp-koroed',
          type: 'Бороздчатая (короед)',
          materialFinishing: 'Минеральная штукатурка',
          materialFinishingSize: '2,0 мм',
          sort: 4,
        },
        {
          id: 24,
          src: '',
          name: 'Минеральная штукатурка REINMANN RP короед 3,0 мм, 25кг, короед',
          count: 0,
          url: '',
          code: 'reinmann-rp-koroed',
          type: 'Бороздчатая (короед)',
          materialFinishing: 'Минеральная штукатурка',
          materialFinishingSize: '3,0 мм',
          sort: 4,
        },
        {
          id: 25,
          src: '',
          name: 'Адгезионная грунтовка Reinmann Status QuarzGrund, 15л',
          count: 0,
          url: '',
          code: 'reinmann-status-quarzgrund',
          type: '',
          sort: 3,
        },
        {
          id: 26,
          src: '',
          name: 'Универсальная грунтовка Reinmann Status SiloxanGrund, 10л',
          count: 0,
          url: '',
          code: 'reinmann-status-siloxangrund',
          type: '',
          sort: 5,
        },
        {
          id: 27,
          src: '',
          name: 'Акриловая фасадная краска  REINMANN STATUS AcrylFarbe, Weiss/BaseA,15л',
          count: 0,
          url: '',
          code: 'reinmann-status-acrylfarbe',
          type: '',
          sort: 6,
        },
        {
          id: 28,
          src: '',
          name: 'Силикатная фасадная краска  REINMANN Silikat FassadenFarbe, Weiss/BaseA, 15л',
          count: 0,
          url: '',
          code: 'reinmann-silikat-fassadenfarbe',
          type: '',
          sort: 6,
        },
        {
          id: 29,
          src: '',
          name: 'Силиконовая краска REINMANN STATUS SilikonFarbe, Weiss/BaseA,15л',
          count: 0,
          url: '',
          code: 'reinmann-status-silikonfarbe',
          type: '',
          sort: 6,
        },
        {
          id: 30,
          src: '',
          name: 'Клей REINMANN KS стандарт',
          count: 0,
          url: '',
          code: 'reinmann-ks-standart',
          type: '',
          sort: 1
        },
        {
          id: 31,
          src: '',
          name: 'Клей REINMANN KU универсал',
          count: 0,
          url: '',
          code: 'reinmann-ku-universal',
          type: '',
          sort: 2,
        },
        {
          id: 32,
          src: '',
          name: 'Дюбель для крепления теплоизоляционных плит длиной 140 мм',
          count: 0,
          url: '',
          code: 'zabivnoy-dyubel-s-metallicheskim-serdechnikom',
          type: '',
          sort: 12,
        },
        {
          id: 33,
          src: '',
          name: 'Дюбель для крепления теплоизоляционных плит длиной 160 мм',
          count: 0,
          url: '',
          code: 'zabivnoy-dyubel-s-metallicheskim-serdechnikom',
          type: '',
          sort: 12,
        },
        {
          id: 34,
          src: '',
          name: 'Дюбель для крепления теплоизоляционных плит длиной 180 мм',
          count: 0,
          url: '',
          code: 'zabivnoy-dyubel-s-metallicheskim-serdechnikom',
          type: '',
          sort: 12,
        },
        {
          id: 35,
          src: '',
          name: 'Дюбель для крепления теплоизоляционных плит длиной 200 мм',
          count: 0,
          url: '',
          code: 'zabivnoy-dyubel-s-metallicheskim-serdechnikom',
          type: '',
          sort: 12,
        },
        {
          id: 36,
          src: '',
          name: 'Дюбель для крепления теплоизоляционных плит длиной 220 мм',
          count: 0,
          url: '',
          code: 'zabivnoy-dyubel-s-metallicheskim-serdechnikom',
          type: '',
          sort: 12,
        },
        {
          id: 37,
          src: '',
          name: 'Дюбель для крепления теплоизоляционных плит длиной 240 мм',
          count: 0,
          url: '',
          code: 'zabivnoy-dyubel-s-metallicheskim-serdechnikom',
          type: '',
          sort: 12,
        },
        {
          id: 38,
          src: '',
          name: 'Дюбель для крепления теплоизоляционных плит длиной 260 мм',
          count: 0,
          url: '',
          code: 'zabivnoy-dyubel-s-metallicheskim-serdechnikom',
          type: '',
          sort: 12,
        },
        {
          id: 39,
          src: '',
          name: 'Дюбель для крепления теплоизоляционных плит длиной 300 мм',
          count: 0,
          url: '',
          code: 'zabivnoy-dyubel-s-metallicheskim-serdechnikom',
          type: '',
          sort: 12,
        },
        {
          id: 40,
          src: '',
          name: 'Сетка фасадная стеклотканевая с щелочестойкой пропиткой (рулон 50 м)',
          count: 0,
          url: '',
          code: 'fasadnaya-ryadovaya-setka-iz-steklovolokna-145-170-g-m-',
          type: '',
          sort: 7,
        },
        {
          id: 41,
          src: '',
          name: 'Профиль угловой ПВХ с армирующей сеткой (2,5 м.п.)',
          count: 0,
          url: '',
          code: 'pvkh-ugolok-s-setkoy',
          type: '',
          sort: 8
        },
        {
          id: 42,
          src: '',
          name: 'Профиль оконного примыкания с сеткой (2,4 м.п.)',
          count: 0,
          url: '',
          code: 'u-obraznyy-pvkh-profil',
          type: '',
          sort: 10,
        },
        {
          id: 43,
          src: '',
          name: 'ПВХ - Профиль Капельник с стеклосеткой (2,5 м.п.)',
          count: 0,
          url: '',
          code: 'pvkh-ugolok-s-kapelnikom-i-setkoy',
          type: '',
          sort: 9,
        },
        {
          id: 44,
          src: '',
          name: 'Цокольный профиль шириной 50 мм (2,5 м.п.)',
          count: 0,
          url: '',
          code: 'tsokolnyy-profil',
          type: '',
          sort: 11,
        },
        {
          id: 45,
          src: '',
          name: 'Цокольный профиль шириной 80 мм (2,5 м.п.)',
          count: 0,
          url: '',
          code: 'tsokolnyy-profil',
          type: '',
          sort: 11,
        },
        {
          id: 46,
          src: '',
          name: 'Цокольный профиль шириной 100 мм (2,5 м.п.)',
          count: 0,
          url: '',
          code: 'tsokolnyy-profil',
          type: '',
          sort: 11,
        },
        {
          id: 47,
          src: '',
          name: 'Цокольный профиль шириной 120 мм (2,5 м.п.)',
          count: 0,
          url: '',
          code: 'tsokolnyy-profil',
          type: '',
          sort: 11,
        },
        {
          id: 48,
          src: '',
          name: 'Цокольный профиль шириной 150 мм (2,5 м.п.)',
          count: 0,
          url: '',
          code: 'tsokolnyy-profil',
          type: '',
          sort: 11,
        },
        {
          id: 49,
          src: 'http://reinmann.ru/upload/mineral-board.jpg',
          name: 'Минераловатная плита (МВП)',
          count: 0,
          url: 'none',
          code: 'none',
          type: '',
          sort: 12,
        },
        {
          id: 50,
          src: 'http://reinmann.ru/upload/poly-board.jpg',
          name: 'Пенополистрольная плита (ПСБ-С 25Ф)',
          count: 0,
          url: 'none',
          code: 'none',
          type: '',
          sort: 12,
        },


      ],
      buttons: {
        1: [{id: 1, title: 'Укажите габаритные размеры здания'}, {id: 2, title: 'Укажите площадь фасада без вычета окон и дверей'}],
        2: []
      },
      fields: {
        length: {id: 1, title: 'Длина здания', value: '', meas: 'м'},
        width: {id: 2, title: 'Ширина здания', value: '', meas: 'м'},
        height: {id: 3, title: 'Высота здания', value: '', meas: 'м'},
        square: {id: 4, title: 'Площадь здания', value: '', meas: 'м'},
        insulationWidth: [
          {id: 1,title: '50 мм'},
          {id: 2, title: '80 мм'},
          {id: 3, title: '100 мм'},
          {id: 4, title: '120 мм'},
          {id: 5, title: '150 мм'},
        ],
        windows: [
          {
            width: {id: 1, title: 'Ширина', value: '', meas: 'м'},
            height: {id: 2, title: 'Высота', value: '', meas: 'м'},
            count: {id: 3, title: 'Количество', value: '', meas: 'шт.'},
          }
        ],
        doors: [
          {
            width: {id: 1, title: 'Ширина', value: '', meas: 'м'},
            height: {id: 2, title: 'Высота', value: '', meas: 'м'},
            count: {id: 3, title: 'Количество', value: '', meas: 'шт.'},
          }
        ],
        materialsWall: [
          {id: 1,title: 'Кирпич полнотелый'},
          {id: 2, title: 'Кирпич многопустотный'},
          {id: 3, title: 'Монолитный железобетон'},
          {id: 4, title: 'Легкие бетонные блоки'},
          {id: 5, title: 'Брус'},
          {id: 6, title: 'Ориентированная стружечная плита'},
        ],
        finishing: [
          {id: 1,title: 'Оштукатуривание без базового слоя'},
          {id: 2, title: 'Теплоизоляция фасада (СФТК)'},
        ],
        insulation: [
          {id: 1,title: 'Минераловатная плита (МВП)'},
          {id: 2, title: 'Пенополистрольная плита (ПСБ-С 25Ф)'},
        ],
        materialsFinishing: [
          {id: 1,title: 'Минеральная штукатурка'},
          {id: 2, title: 'Акриловая штукатурка'},
          {id: 3, title: 'Силикон-силикатная штукатурка'},
          {id: 4, title: 'Силиконовая штукатурка'},
        ],
        materialsFinishingTexture: [
          {id: 1,title: 'Равномерно-шероховатая (шуба)'},
          {id: 2, title: 'Бороздчатая (короед)'},
        ],
        materialsFinishingSize: [
          {id: 1,title: '1,5 мм'},
          {id: 2,title: '2,0 мм'},
          {id: 3,title: '3,0 мм'},
        ],
        materialsFinishingCoating: [
          {id: 1,title: 'Акриловая краска'},
          {id: 2,title: 'Силиконовая краска'},
          {id: 3,title: 'Силикатная краска'},
        ],
      },
      output: null
    }),




    computed: {
      

      materialsFinishing() {

        const initValue = [
          {id: 1,title: 'Минеральная штукатурка'},
          {id: 2, title: 'Акриловая штукатурка'},
          {id: 3, title: 'Силикон-силикатная штукатурка'},
          {id: 4, title: 'Силиконовая штукатурка'},
        ]

        if (this.insulationTitle === 'Минераловатная плита (МВП)' && this.finishing === 'Теплоизоляция фасада (СФТК)') {
          const newValue = initValue.filter(el => el.title !== 'Акриловая штукатурка').map(el => el)
          this.fields.materialsFinishing = newValue
          return newValue
        } else {
          this.fields.materialsFinishing = initValue
          return initValue
        }
      },

      showNotify() {
        this.notify.show = true
        setTimeout(() => {
          this.notify.show = false
        }, 3000)
      },

      consumption() {

        this.resultItems.forEach(item => item.count = 0)

        this.selection.forEach(id => {
          let count = 0
          let insulationRatio = 0
          switch (id) {
            case 1:
              count = 2.5 * this.squareFacade / 25
              break
            case 2:
              count = 3 * this.squareFacade / 25
              break
            case 3:
              count = 4 * this.squareFacade / 25
              break
            case 4:
              count = 3 * this.squareFacade / 25
              break
            case 5:
              count = 2.5 * this.squareFacade / 25
              break
            case 6:
              count = 4 * this.squareFacade / 25
              break
            case 7:
              count = 2.5 * this.squareFacade / 25
              break
            case 8:
              count = 3 * this.squareFacade / 25
              break
            case 9:
              count = 4 * this.squareFacade / 25
              break
            case 10:
              count = 3 * this.squareFacade / 25
              break
            case 11:
              count = 2.5 * this.squareFacade / 25
              break
            case 12:
              count = 4 * this.squareFacade / 25
              break
            case 13:
              count = 2.5 * this.squareFacade / 25
              break
            case 14:
              count = 3 * this.squareFacade / 25
              break
            case 15:
              count = 4 * this.squareFacade / 25
              break
            case 16:
              count = 3 * this.squareFacade / 25
              break
            case 17:
              count = 2.5 * this.squareFacade / 25
              break
            case 18:
              count = 4 * this.squareFacade / 25
              break
            case 19:
              count = 2.5 * this.squareFacade / 25
              break
            case 20:
              count = 3 * this.squareFacade / 25
              break
            case 21:
              count = 4 * this.squareFacade / 25
              break
            case 22:
              count = 3 * this.squareFacade / 25
              break
            case 23:
              count = 2.5 * this.squareFacade / 25
              break
            case 24:
              count = 4 * this.squareFacade / 25
              break
            case 25:
              count = 0.2 * this.squareFacade / 15
              break
            case 26:
              let multiplier = 1
              if ((this.materialWall === 'Кирпич полнотелый'
                  || this.materialWall === 'Кирпич многопустотный'
                  || this.materialWall === 'Легкие бетонные блоки')
                  && this.materialFinishing === 'Минеральная штукатурка') {
                multiplier = 2
              }
              count = 0.15 * this.squareFacade / 10 * multiplier
              break
            case 27:
            case 28:
            case 29:
              count = 0.35 * this.squareFacade / 15
              break
            case 30:
              count = 6 * this.squareFacade / 25
              break
            case 31:
              count = 5 * this.squareFacade / 25
              break
            case 32:
            case 33:
            case 34:
            case 35:
            case 36:
            case 37:
            case 38:
            case 39:
              if (this.insulationTitle === 'Минераловатная плита (МВП)') insulationRatio = 5.5
              if (this.insulationTitle === 'Пенополистрольная плита (ПСБ-С 25Ф)') insulationRatio = 3.5
              count = insulationRatio * this.squareFacade
              break

            case 40:
              count = 1.1 * this.squareFacade / 50
              break
            case 41:
              count = 1.05 * this.perimeterCorner / 2.5
              break
            case 42:
              count = 1.05 * this.perimeterProfile / 2.4
              break
            case 43:
              count = 1.05 * this.perimeterDrip / 2.5
              break
            case 44:
            case 45:
            case 46:
            case 47:
            case 48:
              count = 1.05 * this.perimeterPlinth / 2.5
              break
            case 49:
            case 50:
              let insulationWidth = this.insulationWidth.split(' ')[0]
                console.log(insulationWidth)
              count = (insulationWidth * 0.001) * 1.05 * this.squareFacade
              break
          }

          this.resultItems.filter(item => item.id === id).forEach(item => {
            if (item.id === 49 || item.id === 50) item.count = count.toFixed(2)
            else item.count = Math.ceil(count)
          })

        })

        function compare( a, b ) {
          if ( a.sort < b.sort ){
            return -1;
          }
          if ( a.sort > b.sort ){
            return 1;
          }
          return 0;
        }

        this.resultItems.sort(compare)

        return this.selection.length > 0
      },

      selection() {

        let arSelection = []

        this.resultItems.filter(item => item.type === this.materialFinishingTexture && item.materialFinishing === this.materialFinishing && item.materialFinishingSize === this.materialFinishingSize)
          .forEach(el => {
            arSelection.push(el.id)
          })

        if (this.finishing !== '' || this.insulation) {
          arSelection.push(25)
        }
        if (this.materialWall === 'Кирпич полнотелый'
            || this.materialWall === 'Кирпич многопустотный'
            || this.materialWall === 'Легкие бетонные блоки') {
          arSelection.push(26)
        } else if (this.materialFinishing === 'Минеральная штукатурка') {
          arSelection.push(26)
        }

        if (this.materialFinishing === 'Минеральная штукатурка') {
          switch (this.materialFinishingCoating) {
            case "Акриловая краска":
              arSelection.push(27)
              break
            case "Силикатная краска":
              arSelection.push(28)
              break
            case "Силиконовая краска":
              arSelection.push(29)
              break
          }
        }
        if (this.finishing !== '') {
          if (this.dowelSize < 139) arSelection.push(32)
          else if (this.dowelSize >= 140 && this.dowelSize <= 160) arSelection.push(33)
          else if (this.dowelSize >= 161 && this.dowelSize <= 180) arSelection.push(34)
          else if (this.dowelSize >= 181 && this.dowelSize <= 200) arSelection.push(35)
          else if (this.dowelSize >= 201 && this.dowelSize <= 220) arSelection.push(36)
          else if (this.dowelSize >= 221 && this.dowelSize <= 240) arSelection.push(37)
          else if (this.dowelSize >= 241 && this.dowelSize <= 260) arSelection.push(38)
          else if (this.dowelSize >= 261 && this.dowelSize <= 300) arSelection.push(39)

          const insulationWidth = parseInt(this.insulationWidth.split(' ')[0])

          if (insulationWidth >= 50 && insulationWidth <= 79) arSelection.push(44)
          else if (insulationWidth >= 80 && insulationWidth <= 99) arSelection.push(45)
          else if (insulationWidth >= 100 && insulationWidth <= 119) arSelection.push(46)
          else if (insulationWidth >= 120 && insulationWidth <= 149) arSelection.push(47)
          else if (insulationWidth >= 150) arSelection.push(48)

        }
        
        if (this.finishing === 'Теплоизоляция фасада (СФТК)') arSelection.push(30, 31, 40, 41, 42, 43)
        
        if (this.insulationTitle === 'Минераловатная плита (МВП)') arSelection.push(49)
        if (this.insulationTitle === 'Пенополистрольная плита (ПСБ-С 25Ф)') arSelection.push(50)

        return arSelection;
      },

      perimeterPlinth() {
        return (parseFloat(this.fields.length.value) + parseFloat(this.fields.width.value)) * 2
      },

      dowelSize() {
        let width = 0
        const insulationWidth = this.insulationWidth.split(' ')[0]
        switch (this.materialWall) {

          case "Кирпич полнотелый":
            width = 60
            break
          case "Кирпич многопустотный":
            width = 120
            break
          case "Монолитный железобетон":
            width = 60
            break
          case "Легкие бетонные блоки":
            width = 80
            break
          case "Брус":

            width = -parseFloat(insulationWidth)
            break
          case "Ориентированная стружечная плита":
            width = -parseFloat(insulationWidth)
            break
        }

        return width + parseFloat(insulationWidth)
      },

      perimeterDrip() {
        let resultWindows = 0
        let resultDoors = 0

        this.fields.windows.forEach(el => {
          resultWindows += parseFloat(el.width.value) * parseFloat(el.count.value)
        })
        this.fields.doors.forEach(el => {
          resultDoors += parseFloat(el.width.value) * parseFloat(el.count.value)
        })

        return resultWindows + resultDoors
      },

      perimeterProfile() {
        let resultWindows = 0
        let resultDoors = 0

        this.fields.windows.forEach(el => {
          resultWindows += (parseFloat(el.height.value) + parseFloat(el.height.value) + parseFloat(el.width.value)) * parseFloat(el.count.value)
        })
        this.fields.doors.forEach(el => {
          resultDoors += (parseFloat(el.height.value) + parseFloat(el.height.value) + parseFloat(el.width.value)) * parseFloat(el.count.value)
        })

        return resultWindows + resultDoors
      },

      perimeterCorner() {
        let result = parseFloat(this.fields.height.value) * 4
        let resultWindows = 0
        let resultDoors = 0

        this.fields.windows.forEach(el => {
          resultWindows += (parseFloat(el.height.value) + parseFloat(el.height.value) + parseFloat(el.width.value)) * parseFloat(el.count.value)
        })
        this.fields.doors.forEach(el => {
          resultDoors += (parseFloat(el.height.value) + parseFloat(el.height.value)) * parseFloat(el.count.value)
        })

        return result + resultWindows + resultDoors
      },

      squareFacade() {
        let squareValue = 0
        let dimensions = 0
        if (dimensions === 0 && this.fields.square.value !== '') {
          squareValue = parseFloat(this.fields.square.value)
        }
        if (squareValue === 0 && this.fields.length.value !== '' && this.fields.width.value !== '' && this.fields.height.value !== '') {
          dimensions = ((parseFloat(this.fields.length.value) + parseFloat(this.fields.width.value)) * 2) * parseFloat(this.fields.height.value)
        }
        
        const result = (squareValue + dimensions) - this.squareWindowDoors

        return result.toFixed(2)
      },

      squareWindowDoors() {
        let result = 0

        this.fields.windows.forEach(el => {
          result += (parseFloat(el.height.value) * parseFloat(el.width.value)) * parseFloat(el.count.value)
        })
        this.fields.doors.forEach(el => {
          result += (parseFloat(el.height.value) * parseFloat(el.width.value)) * parseFloat(el.count.value)
        })

        return result.toFixed(2)
      },

      countDoors() {
        let count = 0
        this.fields.doors.map((door) => {
          count += Number(door.count.value)
        })
        return count
      },
      countWindows() {
        let count = 0
        this.fields.windows.map((window) => {
          count += Number(window.count.value)
        })
        return count
      },

    },

    created() {
      this.fetchItems()
      
    },


    methods: {

      showMobileDataForPrint() {
        this.showMobileData = true
      },


      showMobileDataExpand () {
        this.showMobileData = !this.showMobileData
      },


      transliteration(words) {
        String.prototype.translit = String.prototype.translit || function () {
          let Chars = {
                'а': 'a', 'б': 'b', 'в': 'v', 'г': 'g', 'д': 'd', 'е': 'e', 'ё': 'yo', 'ж': 'zh', 'з': 'z', 'и': 'i', 'й': 'y', 'к': 'k', 'л': 'l', 'м': 'm', 'н': 'n', 'о': 'o', 'п': 'p', 'р': 'r', 'с': 's', 'т': 't', 'у': 'u', 'ф': 'f', 'х': 'h', 'ц': 'c', 'ч': 'ch', 'ш': 'sh', 'щ': 'shch', 'ъ': '', 'ы': 'y', 'ь': '', 'э': 'e', 'ю': 'yu', 'я': 'ya', 'А': 'A', 'Б': 'B', 'В': 'V', 'Г': 'G', 'Д': 'D', 'Е': 'E', 'Ё': 'YO', 'Ж': 'ZH', 'З': 'Z', 'И': 'I', 'Й': 'Y', 'К': 'K', 'Л': 'L', 'М': 'M', 'Н': 'N', 'О': 'O', 'П': 'P', 'Р': 'R', 'С': 'S', 'Т': 'T', 'У': 'U', 'Ф': 'F', 'Х': 'H', 'Ц': 'C', 'Ч': 'CH', 'Ш': 'SH', 'Щ': 'SHCH', 'Ъ': '', 'Ы': 'Y', 'Ь': '', 'Э': 'E', 'Ю': 'YU', 'Я': 'YA'
              },
              t = this;
          for (let i in Chars) { t = t.replace(new RegExp(i, 'g'), Chars[i]); }
          return t;
        };

        return words.translit()
      },

      async fetchItems() {

        const items = this.resultItems.map(el => el.code)
        const { data } = await axios.get(`${process.env.VUE_APP_API_HOST}api/v1/items?act=fetch_items&items=${JSON.stringify(items)}`);

        data.forEach(fetch_element => {
          
          if (this.checkMod) {
            fetch_element.src = `http://reinmann.ru${fetch_element.src}`
          }

          this.resultItems.forEach(el => {
            

            if (el.code === fetch_element.code) {
              el.src = fetch_element.src
              el.url = fetch_element.url
            }
          })
        })
  
        this.resultItems.forEach(el => {
    
          if (el.code === '') {
            console.log(el)
          }
        })


      },

      async saveFeedback() {

        const resultData = {
          'Длина': `${this.fields.length.value} ${this.fields.length.meas}`,
          'Высота': `${this.fields.height.value} ${this.fields.height.meas}`,
          'Ширина': `${this.fields.width.value} ${this.fields.width.meas}`,
          'Площадь': `${this.fields.square.value} ${this.fields.square.meas}`,
          'Количество окон': `${this.countWindows}`,
          'Количество дверей': `${this.countDoors}`,
          'Тип стены': `${this.materialWall}`,
          'Тип отделки': `${this.finishing}`,
          'Вид утеплителя': `${this.insulationTitle}`,
          'Толщина утеплителя': `${this.insulationWidth}`,
          'Тип штукатурки': `${this.materialFinishing}`,
          'Фактура': `${this.materialFinishingTexture}`,
          'Размер зерна': `${this.materialFinishingSize}`,
          'Финишное покрытие': `${this.materialFinishingCoating}`,
        }

        const { data } = await axios.get(`${process.env.VUE_APP_API_HOST}api/v1/feedback?act=add&data=${JSON.stringify(this.form)}&result=${JSON.stringify(resultData)}`)
        if (data.id > 0) this.showModal = false
      },

      sendForm() {
        if (this.form.name !== '' && this.form.email !== '' && this.form.phone !== '') {
          this.saveFeedback()
          this.showNotify
          this.notify.message = 'Сообщение отправлено'
        } else {
          this.showNotify
          this.notify.message = 'Имя, E-mail, Телефон - обязательные поля'
        }
      },

      showFormConsultation () {
        this.showModal = true
      },

      async payment(action) {


        const el = this.$refs.print;
        const elResult = this.$refs.printResult;
        const elHouse = this.$refs.printHouse;
        const elIcon = this.$refs.icon;
        const wIcon = elIcon.offsetWidth;
        const hIcon = elIcon.offsetHeight;
        const wResult = elResult.offsetWidth;
        const hResult = elResult.offsetHeight;
        const wHouse = elHouse.offsetWidth;
        const hHouse = elHouse.offsetHeight;
        const wEl = el.offsetWidth;
        const hEl = el.offsetHeight;
        const w = el.offsetWidth + elResult.offsetWidth;
        const h = el.offsetHeight + elResult.offsetHeight + elHouse.offsetHeight;

        const objData = new Date()

        const options = {
          dpi: 100,
          scale: 1,
          useCORS: true,
          type: 'dataURL',
        }
        const optionsHouse = {
          dpi: 100,
          scale: 1,
          useCORS: true,
          type: 'dataURL',
        }
        const canvas = await this.$html2canvas(el, options)
        const canvasResult = await this.$html2canvas(elResult, options)
        const canvasHouse = await this.$html2canvas(elHouse, optionsHouse)
        const canvasIcon = await this.$html2canvas(elIcon, options)
        const format = [wEl, Math.max(wEl * 1.414 + 20, h)]


        const doc = new jsPDF('p', 'px', format);
        doc.addImage(canvasIcon, 'JPG', 100, hHouse / 4 + 70, wIcon, hIcon);
        doc.addImage(canvasHouse, 'JPG', wIcon, 0, wHouse, hHouse);
        doc.addImage(canvasResult, 'JPG', wIcon + wHouse, 70, wResult, hResult);
        doc.addImage(canvas, 'JPG', 0, Math.max(hHouse, hResult) , wEl, hEl);

        if (action === 'save') {
          doc.save(`report ${objData.toDateString()}.pdf`)
        }
        if (action === 'print') {
          window.open(doc.output('bloburl'), '_blank');
        }


      },
  
      async paymentMobile() {
    
        await this.showMobileDataForPrint()
    
        const el = this.$refs.print;
        const elResultM = this.$refs.printResultMobile;
        const elHouse = this.$refs.printHouse;
        const elIcon = this.$refs.icon;
        const wIcon = elIcon.offsetWidth;
        const hIcon = elIcon.offsetHeight;
        const wResult = elResultM.offsetWidth;
        const hResult = elResultM.offsetHeight;
        const wHouse = elHouse.offsetWidth;
        const hHouse = elHouse.offsetHeight;
        const wEl = el.offsetWidth;
        const hEl = el.offsetHeight;
        const w = el.offsetWidth + elResultM.offsetWidth;
        const h = el.offsetHeight + elResultM.offsetHeight + elHouse.offsetHeight;
    
        const objData = new Date()
    
        const options = {
          dpi: 100,
          scale: 1,
          useCORS: true,
          type: 'dataURL',
        }
        const optionsHouse = {
          dpi: 100,
          scale: 1,
          useCORS: true,
          type: 'dataURL',
        }
        const canvas = await this.$html2canvas(el, options)
        const canvasResultM = await this.$html2canvas(elResultM, options)
        const canvasHouse = await this.$html2canvas(elHouse, optionsHouse)
        const canvasIcon = await this.$html2canvas(elIcon, options)
        const format = [wEl, Math.max(wEl * 1.414 + 20, h)]
    
    
        const doc = new jsPDF('p', 'px', format);
        doc.addImage(canvasHouse, 'JPG', 0, 0, wHouse, hHouse);
        doc.addImage(canvasIcon, 'JPG', wHouse + 40, hHouse / 3, wIcon, hIcon);
        doc.addImage(canvas, 'JPG', 0, Math.max(hHouse, hResult) , wEl, hEl);
        doc.addImage(canvasResultM, 'JPG', 0, hHouse + hEl, wResult, hResult);
    
        
        doc.save(`report ${objData.toDateString()}.pdf`)
        
    
    
      },

      setMaterialImage(title, position) {
        if (position === 0) {
          if (this.materialFinishingTexture === '') this.materialImage = title
          if (this.materialFinishingTexture !== '') {
            this.materialImage = `${title}-${this.materialFinishingTexture}`
          }
        }
        if (position === 1) {
          if (this.materialFinishing === '') return
          if (this.materialFinishing !== '') {
            this.materialImage = `${this.materialFinishing}-${title}`
          }
        }
      },

      selectMaterialFinishingCoating(title) {
        this.materialFinishingCoating = title
      },

      selectMaterialFinishingSize(title) {
        this.materialFinishingSize = title
      },
      selectMaterialFinishingTexture(title) {
        this.materialFinishingTexture = title
        this.setMaterialImage(title, 1)
      },
      selectMaterialFinishing(title) {
        this.materialFinishing = title
        this.setMaterialImage(title, 0)
      },
      selectInsulationWidth(title) {
        this.insulationWidth = title
      },
      selectInsulation(title) {
        this.insulationTitle = title
      },

      getImgUrl(title, dir) {
        const translateTitle = this.transliteration(title)
        return require(`./assets/images/${dir}/${translateTitle}.jpg`)
      },

      selectFinishing(title) {
        this.finishing = title
        this.insulation = title === 'Теплоизоляция фасада (СФТК)'
      },
      selectMaterialWall(title) {
        this.materialWall = title
        this.materialImage = title
      },

      isNumber: function(evt) {

        evt = (evt) ? evt : window.event;
        let charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46 && charCode !== 44) {
          evt.preventDefault();
        } else if (evt.target.value.length === 0 && charCode === 48) {
          evt.preventDefault();
        } else {
          if (evt.target.value.indexOf(".") !== -1) {
            evt.target.value = evt.target.value.substring(0, evt.target.value.indexOf(".") + 2);
          }
          if (evt.target.value.indexOf(",") !== -1) {
            evt.target.value = evt.target.value.substring(0, evt.target.value.indexOf(",") + 2);
            evt.target.value = evt.target.value.replace(',', '.')
          }
          return true;
        }
      },

      changeActiveButton(id) {
        
        if (id === 2) {
          this.fields.width.value = ''
          this.fields.length.value = ''
          this.fields.height.value = ''
        }
  
        if (id === 1) {
          this.fields.square.value = ''
        }
        
        this.buttonsStep = id
        
      },
      addItem() {

        this.fields.windows.push({
          width: {id: 1, title: 'Ширина', value: '', meas: 'м'},
          height: {id: 2, title: 'Высота', value: '', meas: 'м'},
          count: {id: 3, title: 'Количество', value: '', meas: 'шт.'},
        })
      },
      deleteWindow(index) {
        this.fields.windows = this.fields.windows.filter((el, i) => index !== i).map(el => el)
      },
      addDoor() {

        this.fields.doors.push({
          width: {id: 1, title: 'Ширина', value: '', meas: 'м'},
          height: {id: 2, title: 'Высота', value: '', meas: 'м'},
          count: {id: 3, title: 'Количество', value: '', meas: 'шт.'},
        })
      },
      deleteDoor(index) {
        this.fields.doors = this.fields.doors.filter((el, i) => index !== i).map(el => el)
      },
      nextStep() {

        this.activeStep +=1
        if (this.activeStep === 2) {

          let backStep = false

          if ((!this.fields.length.value.length || !this.fields.width.value.length || !this.fields.height.value.length) && !this.fields.square.value.length) {
            this.activeStep = 1
            return
          }
          
          
          if (this.fields.windows.length || this.fields.doors.length) {
            if (this.fields.windows.length) {
              this.fields.windows.forEach(el => {
                if (!el.width.value.length || !el.height.value.length || !el.count.value.length) {
                  this.activeStep = 1
                  backStep = true
                }
              })
            }
            if (this.fields.doors.length) {
              this.fields.doors.forEach(el => {
                if (!el.width.value.length || !el.height.value.length || !el.count.value.length) {
                  this.activeStep = 1
                  backStep = true
                }
              })
            }
          } else {
            this.activeStep = 1
            backStep = true
          }
          
          // Старая логика выбора окнон и дверей как обязательные поля
          
          // if (!this.fields.windows.length) {
          //   this.activeStep = 1
          //   backStep = true
          // } else {
          //   this.fields.windows.forEach(el => {
          //     if (!el.width.value.length || !el.height.value.length || !el.count.value.length) {
          //       this.activeStep = 1
          //       backStep = true
          //     }
          //   })
          // }
          //
          // if (!this.fields.doors.length) {
          //   this.activeStep = 1
          //   backStep = true
          // } else {
          //   this.fields.doors.forEach(el => {
          //     if (!el.width.value.length || !el.height.value.length || !el.count.value.length) {
          //       this.activeStep = 1
          //       backStep = true
          //     }
          //   })
          // }
          
          


          if (backStep) {
            return
          }

          this.buttonsStep = 0

        }
        if (this.activeStep === 3) {

          if (!this.materialWall.length || !this.finishing.length) {
            this.activeStep = 2
          }
          if (this.finishing === 'Теплоизоляция фасада (СФТК)') {
            if (!this.insulationTitle.length || !this.insulationWidth.length) {
              this.activeStep = 2
            }
          }

        }
        if (this.activeStep === 4) {

          if (this.materialFinishing === 'Минеральная штукатурка')  {
            if (!this.materialFinishing.length || !this.materialFinishingTexture.length || !this.materialFinishingSize.length || !this.materialFinishingCoating.length) {
              this.activeStep = 3
            }
          } else if (this.materialFinishing !== 'Минеральная штукатурка') {
            if (!this.materialFinishing.length || !this.materialFinishingTexture.length || !this.materialFinishingSize.length) {
              this.activeStep = 3
            }
          }
        }

        if (this.activeStep === 4 && !this.consumption) this.activeStep -=1


      },
      previousStep() {
        this.activeStep -=1
        if (this.activeStep === 2) {
          this.buttonsStep = 0
        } else if (this.activeStep === 1) {
          this.buttonsStep = 1
        }
      }
    }
  }
</script>

<style lang="scss" scoped>

  .mobile-data {
    font-size: 14px;
    font-family: HelveticaNeueCyr-Light;
    div {
      margin-bottom: 10px;
    }
  }

  .title-mobile-data-container {
    display: flex;
    justify-content: space-between;
  }

  .title-mobile-data {
    color: #924e8c;
    text-transform: uppercase;
    font-size: 14px;
    font-family: HelveticaNeueCyr-Medium;
    margin-top: 2rem;
    img {
      margin-top: -5px;
    }
  }

  .choose-button {
    @media screen and (max-width: 700px) {
      font-size: 14px;
    }
  }

  .mob-icon-material {
    @media screen and (max-width: 700px) {
      margin-left: 10%;
    }
  }

  .mob-place-1 {
    @media screen and (max-width: 700px) {
      order: 1
    }
  }
  .mob-place-2 {
    @media screen and (max-width: 700px) {
      order: 2;

    }
  }

  .notify-vue {
    transition: all 300ms;
    background-color: #924e8c;
    padding: 3rem;
    position: absolute;
    bottom: 0;
    right: 0;
    z-index: 99999999999;
    color: white;
    min-width: 300px;
    text-align: center;
    margin-bottom: 1rem;
    margin-right: 1rem;
    border-radius: 4px;
  }

  .text-agree {
    font-size: 12px;
  }

  .form-button {
    transition: all 300ms;
    text-transform: uppercase;
    padding: .8rem 4rem;
    background-color: #924e8c;
    border: 1px solid white;
    color: white;
    cursor: pointer;

  }

  .modal-container-wrapper {
    padding: 2rem 4rem;
    @media screen and (max-width: 700px) {

      padding: 2rem 1rem;
    }

    input, textarea {
      width: 100%;
      padding: .8rem 1rem;
      font-size: 16px;
      line-height: 16px;
      margin-bottom: 1rem;
      font-family: HelveticaNeueCyr-Medium;
      @media screen and (max-width: 700px) {
        border: 1px solid #7c7c7c;
        font-family: HelveticaNeueCyr-Light;
        padding: 1rem 1rem;
      }
      &::placeholder {

      }
      &:focus, active {
        outline-color: #924e8c;
      }
    }
    textarea {
      height: 100px;
    }

  }

  .close-vue {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    margin-top: -10px;
    margin-left: auto;
    cursor: pointer;
    margin-bottom: 40px;
    @media screen and (max-width: 700px) {
      margin-left: 98%;
      margin-top: 0px;

    }
  }

  .modal-header-vue {
    margin-top: 2rem;
    text-transform: uppercase;
    color: #333333;
    text-align: center;
    font-family: HelveticaNeueCyr-Medium;
    @media screen and (max-width: 700px) {
      padding: 0 1rem;
      text-align: left;
      font-size: 15px;
      line-height: 19px;
    }


  }

  .bottom-bar {
    margin-top: 4rem;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .item {

      .next-button {
        text-align: center;
        text-transform: unset;
        font-size: 14px;
        margin-top: 0;
        padding: .7rem .8rem;
        max-width: 100%;

      }
      .previous-button {
        font-size: 14px;
        margin-top: 0;
        padding: .7rem .8rem;
        max-width: 100%;
      }
      .button-add {
        font-size: 14px;
        text-align: center;


      }
    }
  }

  .table {
    .table-head {
      padding: 1rem 0;
      display: flex;
      background-color: #e4c9dd;
      .column {
        @media screen and (max-width: 700px) {
          padding: 0 .5rem;
        }
        text-align: center;
        &.image {
          flex: 1
        }
        &.name {
          flex: 2
        }
        &.count {
          flex: 1
        }
      }
    }
    .table-body {
      display: flex;
      align-items: center;
      .column {
        text-align: center;
        padding: 1rem 0;
        &.image {
          flex: 1;
          img {
            width: 50%;
            @media screen and (max-width: 700px) {
              width: 90%;
            }
          }
        }
        &.name {
          flex: 2;
          a {
            text-decoration: none;
            color: #303030;
          }
          &:hover {
            a {
              color: #924e8c;
            }
          }
        }
        &.count {
          flex: 1
        }
      }
    }
  }

  .box-title-final {
    text-transform: uppercase;
    font-family: HelveticaNeueCyr-Medium;
    font-size: 2em;
    margin: 2rem 0;
    color: #924e8c;
    @media screen and (max-width: 700px) {
      font-size: 1.5em;
      margin: .3rem 0 2rem 0;
    }

  }

  .result-container {
    color: #303030;
  }

  .search-material-container {
    margin-top: 50px;
    transition: 200ms all;
    width: 110px;
    height: 110px;
    background-image: url("./assets/images/search.svg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    padding: 9px;
    @media screen and (max-width: 700px) {
      margin-top: 10px;
      margin-left: auto;
      width: 55px;
      height: 55px;
      padding: 4px;
    }
    &:hover {
      //background-size: 1% 1%;

    }
    .search-material {
      width: 70%;
      height: 70%;
      border-radius: 50%;
      img {
        transition: 200ms all;
        width: 100%;
        border-radius: 50%;
        z-index: 100;
        position: relative;
        &:hover {
          width: 300px;
          margin-left: -100px;
          margin-top: -100px;
          @media screen and (max-width: 700px) {
            width: 300%;
            margin-left: -100%;
            margin-top: -30%;
          }
        }
      }
    }

  }

  .select-button-container {
    margin-left: -8px;
    margin-right: -8px;
  }

  .select-button {
    padding: 1rem;
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    line-height: 1.3rem;
    -webkit-box-shadow: 1px 1px 20px 0 #cdcdcd;
    box-shadow: 1px 1px 20px 0 #cdcdcd;
    cursor: pointer;
    @media screen and (max-width: 700px) {
      padding: .5rem;
    }
    &.active {
      background-color: #924e8c;
      color: white;
    }
  }

  .next-button {
    transition: all 300ms;
    margin-top: 2rem;
    text-transform: uppercase;
    padding: .8rem 4rem;
    border: 1px solid;
    cursor: pointer;
    @media screen and (max-width: 700px) {
      margin-top: 1rem;
      padding: .6rem 3rem;
      font-size: 14px;
      background-color: #924e8c;
      border: 1px solid white;
      color: white;
    }
    &:hover {
      background-color: #924e8c;
      border: 1px solid white;
      color: white;
    }
    &.mob {
      @media screen and (max-width: 700px) {
        text-transform: unset;
        font-size: 14px;
        padding: .2rem 2rem;
        text-align: center;
      }
    }
  }

  .previous-button {
    transition: all 300ms;
    margin-top: 2rem;
    text-transform: uppercase;
    padding: .8rem 4rem;
    cursor: pointer;
    @media screen and (max-width: 700px) {
      margin-top: 1rem;
      padding: .6rem 2rem;
      font-size: 14px;
    }
    &:hover {
      color: #924e8c;
    }
  }

  .button-add {
    border-bottom: 1px dotted white;
    cursor: pointer;
    @media screen and (max-width: 700px) {
      font-size: 13px;
      text-align: center;
      text-decoration: underline;
    }
    &:hover {
      color: #924e8c;
      border-bottom: 1px dotted #924e8c;
    }
  }

  .box-title {
    text-transform: uppercase;
    font-family: HelveticaNeueCyr-Medium;
    margin: 2rem 0;
    @media screen and (max-width: 700px) {
      font-size: 14px;
      line-height: 18px;
      text-align: center;
      margin: 1rem 0;
    }
  }


  .fields {
    .box {
      .mob-padding-0 {
        @media screen and (max-width: 700px) {
          padding: 0;
        }

      }
      .mob-mb {
        @media screen and (max-width: 700px) {
          margin-bottom: 10px;
        }

      }
      @media screen and (max-width: 700px) {
        padding: 1rem;
      }
      .label-field {
        margin-bottom: 7px;
        font-family: HelveticaNeueCyr-Medium;
        @media screen and (max-width: 700px) {
          font-size: 12px;
          font-weight: 400;
          padding-left: 10px;
          margin-bottom: 20px;
        }
      }
      .title-field {
        margin-bottom: 10px;
        @media screen and (max-width: 700px) {
          font-size: 12px;
        }
      }
      margin-top: 2rem;
      -webkit-box-shadow: 1px 1px 20px 0 #cdcdcd;
      box-shadow: 1px 1px 20px 0 #cdcdcd;
      padding: 1rem 2rem;
      .input-group {
        span {
          font-size: 12px;
        }
        @media screen and (max-width: 700px) {
          margin-bottom: 10px;
        }
        label {
          @media screen and (max-width: 700px) {
            min-width: 50%;
            display: inline-block;
            font-size: .9em;
          }
        }
        input {
          width: 50px;
          height: 30px;
          margin: 0 10px;
          text-align: center;
          color: #924e8c;
          font-size: 16px;
          @media screen and (max-width: 700px) {
            width: 30%;
            display: inline-block;
          }
          &:focus, &:active {
            outline-color: #924e8c;
          }
          &.long {
            width: calc(100% - 40px);
            margin-left: 0;

            @media screen and (max-width: 700px) {
              width: calc(100% - 30px);
              margin-right: 5px;
            }

          }
        }
      }
    }
  }



  .timeline {
    .line {
      margin-top: 10px;
      height: 3px;
      background-color: #eaeaea;
      @media screen and (max-width: 700px){
        height: 1px;
      }
      .filled-line {
        height: 3px;
        background-color: #924e8c;
        @media screen and (max-width: 700px){
          height: 1px;
        }
      }
    }
  }

  .actions {
    margin-top: 2rem;
    .button-action {
      text-transform: uppercase;
      padding: 1rem 2rem;
      text-align: center;
      font-family: HelveticaNeueCyr-Medium;
      line-height: 1.3rem;
      -webkit-box-shadow: 1px 1px 20px 0 #cdcdcd;
      box-shadow: 1px 1px 20px 0 #cdcdcd;
      cursor: pointer;
      @media screen and (max-width: 700px){
        padding: .5rem .5rem;
        font-size: 12px;
        line-height: 14px;
      }
      &.active {
        background-color: #924e8c;
        color: white;
      }
      &.disable {
        opacity: .3;
      }
    }
  }

  .step {
    text-align: center;
    font-size: 27px;
    color: #eaeaea;
    font-family: HelveticaNeueCyr-Medium;
    @media screen and (max-width: 700px){
      font-size: 17px;
    }
    &.active {
      color: #924e8c;

    }
  }

  .title-big {
    margin-top: 10px;
    text-transform: uppercase;
    font-size: 27px;
    color: #924e8c;
    font-family: HelveticaNeueCyr-Bold;
    @media screen and (max-width: 700px) {
      font-size: 20px;
    }
  }
  .title-small {
    text-transform: uppercase;
    font-size: 14px;
    color: #2d2d2d;
    @media screen and (max-width: 700px) {
      font-size: 11px;
    }
  }

  .house {
    img {
      width: 100%;
    }
  }


  #app {
    font-family: -apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,"Helvetica Neue",Arial,"Noto Sans",sans-serif,"Apple Color Emoji","Segoe UI Emoji","Segoe UI Symbol","Noto Color Emoji";
    margin-bottom: 6rem;
  }
  @font-face {
    font-family: "HelveticaNeueCyr-Light";
    src: local("HelveticaNeueCyr-Light"),
    url('./assets/fonts/HelveticaNeueCyr/HelveticaNeueCyr-Light.woff2') format("woff");
  }
  @font-face {
    font-family: "HelveticaNeueCyr-Medium";
    src: local("HelveticaNeueCyr-Medium"),
    url('./assets/fonts/HelveticaNeueCyr/HelveticaNeueCyr-Medium.woff2') format("woff");
  }
  @font-face {
    font-family: "HelveticaNeueCyr-Bold";
    src: local("HelveticaNeueCyr-Bold"),
    url('./assets/fonts/HelveticaNeueCyr/HelveticaNeueCyr-Bold.woff2') format("woff");
  }
  .material-design-icon.action-delete {
    cursor: pointer;
    svg {
      @media screen and (max-width: 700px){
        width: 18px;
      }
    }
    &:hover {
      path {
        fill: #924e8c
      }
    }
  }

  .modal-mask {
    position: fixed;
    z-index: 9998;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: table;
    transition: opacity 0.3s ease;
  }

  .modal-wrapper {
    display: table-cell;
    vertical-align: middle;
  }

  .modal-container {
    width: 70%;
    min-width: 300px;
    margin: 0 auto;
    background-color: #fff;
    border-radius: 2px;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
    transition: all 0.3s ease;
    font-family: Helvetica, Arial, sans-serif;
  }

  .modal-header h3 {
    margin-top: 0;
    color: #42b983;
  }

  .modal-body-vue {
    margin: 20px 0;
  }

  .modal-default-button {
    float: right;
  }

  /*
	 * The following styles are auto-applied to elements with
	 * transition="modal" when their visibility is toggled
	 * by Vue.js.
	 *
	 * You can easily play with the modal transition by editing
	 * these styles.
	 */

  .modal-enter {
    opacity: 0;
  }

  .modal-leave-active {
    opacity: 0;
  }

  .modal-enter .modal-container,
  .modal-leave-active .modal-container {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }
</style>
